import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "./BankAccountTransactions";

export class SetTransactionActivityChannel {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], uuid:string|number, activity_code:string, channel_code: string, listFilters?): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
      activity_code: activity_code,
      channel_code: channel_code,
      bank_account_id: uuid
    }
    try {
      await this.dispatcher.dispatch('set.transactions.activitychannel', args)
      await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(uuid, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)
    } catch (error) {
      console.error('Error update transactions activity and channel', error)
    }
  }
}